import { CIMSColumn } from '../../../../CIMSColumn/types'
import { Entity, RPTQuickLink } from '../types'
import { Help } from '../constants'
import CIMSLink from 'components/CIMSLink'

export function useColumns({ entity }: Entity): CIMSColumn<RPTQuickLink>[] {
  return [
    {
      title: 'Label',
      help: Help.Label(entity),
      width: 250,
      render: 'label',
      sort: { with: 'key', key: 'label', default: 'ascend' },
      filter: {
        type: 'search',
        with: 'key',
        key: 'label',
      },
    },
    {
      title: 'Reference',
      help: Help.Reference,
      width: 300,
      render: ({ href }) => (
        <CIMSLink external href={href}>
          {href}
        </CIMSLink>
      ),
      sort: { with: 'key', key: 'href' },
      filter: {
        type: 'search',
        with: 'key',
        key: 'href',
      },
    },
    /**
     * not use useOptionalDescriptionColumn here on purpose since the help message
     * is generated by that hook and we want to use a help message here
     */
    {
      title: 'Description',
      render: 'description',
      width: 400,
      help: Help.Description,
      filter: {
        type: 'search',
        with: 'callback',
        onFilter: (value, { description }) => {
          if (!description) return false
          return description
            .toLowerCase()
            .includes(value.toString().toLowerCase())
        },
      },
    },
  ]
}
